import { Box, Button, LinearProgress } from "@mui/material";
import { UploadIcon } from "../../Icons/Icons";
import { useAppDispatch, useAppSelector } from "../../store";
import { onRunPredictionAction } from "../../store/actions/PredictionActions";
import { getUploadedLocatorData } from "../../store/selectors/LocatorSelectors";
import { getUploadedScrewData } from "../../store/selectors/ScrewSelectors";
import { getPredictionRunningState } from "../../store/selectors/PredictionSelectors";
import UploadMessages from "../UploadMessages";
import { useCallback, useEffect } from "react";
import { resetLocatorSlice } from "../../store/reducers/LocatorsReducers";
import {
  updatePredictionRunningState,
  updatePredictionStep,
} from "../../store/reducers/PredictionReducers";
import "./css/PredictionOverview.scss";

const PredictionOverview = () => {
  const dispatch = useAppDispatch();
  const uploadedLocatorData = useAppSelector(getUploadedLocatorData);
  const uploadedScrewData = useAppSelector(getUploadedScrewData);
  // One of the two should be null, print warning if not:
  if (uploadedLocatorData && uploadedScrewData) {
    console.warn("Both locator and screw data are present, this should not happen");
  }
  
  const predictionRunningState = useAppSelector(getPredictionRunningState);

  const isPredictionRunning = predictionRunningState === "loading";
  const isPredictionDone = predictionRunningState === "success";
  const isPredictionFailed = predictionRunningState === "error";

  useEffect(() => {
    if (!isPredictionDone) return;
    dispatch(updatePredictionStep(3));
  }, [isPredictionDone, dispatch]);

  const onRunPredClick = useCallback(() => {
    if (!isPredictionFailed) return dispatch(onRunPredictionAction());

    dispatch(resetLocatorSlice());
    dispatch(updatePredictionStep(1));
    dispatch(updatePredictionRunningState("idle"));
  }, [isPredictionFailed, dispatch]);

  const runBtnText = useCallback(() => {
    if (isPredictionFailed) return <>Retry?</>;
    return (
      <>
        <UploadIcon /> Run prediction
      </>
    );
  }, [isPredictionFailed]);

  const predictionControls = (
    <div className="prediction-controls">
      <div className="row">
        <Button
          className="btn btn-blue"
          variant="contained"
          onClick={onRunPredClick}
        >
          {runBtnText()}
        </Button>
      </div>
      {!isPredictionFailed && (
        <div className="row">
          <Button
            variant="outlined"
            className="btn btn-outlined"
            onClick={() => dispatch(updatePredictionStep(1))}
          >
            Change image
          </Button>
        </div>
      )}
    </div>
  );

  const loader = (
    <div className="loader-wrapper">
      <div className="loader">
        <Box sx={{ width: "100%" }}>
          <LinearProgress
            classes={{
              colorPrimary: "progress-bg",
              bar: "progress-bar",
            }}
          />
        </Box>
      </div>
    </div>
  );

  return (
    <div className="prediction-wrapper">
      {isPredictionFailed && (
        <UploadMessages msgType="error" message="Prediction run Failed" />
      )}
      {!isPredictionFailed && (
        <div className="img-holder">
          <img
            src={uploadedLocatorData?.path || uploadedScrewData?.[0]?.imagepath}
            alt={uploadedLocatorData?.locatorid || uploadedScrewData?.[0]?.sampleid}
          />
        </div>
      )}
      {isPredictionRunning ? loader : predictionControls}
    </div>
  );
};

export default PredictionOverview;
